export const getPerdiemRequestApprovalDetails = (state) =>
  state.perdiemRequestApprovalDetails.results;